import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Model from "../Model";
import tw from "tailwind-styled-components";
import {
    CancelBtn,
    InputGroup,
    Label,
    SideCancelBtn,
    SubmitBtn,
} from "../Styles/InputStyles";
import Loading from "../Loading";
import Config from "../../Config";

const validationSchema = Yup.object({
    roomNumber: Yup.string()
        .min(1, "Room number must be at least 1 character")
        .max(5, "Room number must be at most 5 characters")
        .required("Room number is required"),
});

const EditFlat = ({
    setFlatModel,
    selectedData,
    editFlatNumberLoading,
    editFlatNumberMutate,
    activateFlatLoading,
    activateFlatMutate,
    deactivateFlatLoading,
    deactivateFlatMutate,
}) => {
    const initialValues = {
        roomNumber: selectedData?.flatName || "",
        flatId: selectedData?.flatId,
    };

    const handleEditSubmit = (values) => {
        editFlatNumberMutate({
            flatId: selectedData.flatId,
            newName: values.roomNumber,
        });
    };

    const handleRoomStatus = () => {
        if (selectedData.flatStatus === Config.FLAT_STATUS.INACTIVE) {
            activateFlatMutate({
                flatId: selectedData.flatId
            });
        } else if (selectedData.flatStatus === Config.FLAT_STATUS.ACTIVE) {
            deactivateFlatMutate({
                flatId: selectedData.flatId
            });;
        }
    };
    const isActivateRoom = selectedData.flatStatus === Config.FLAT_STATUS.INACTIVE;
    const buttonText = isActivateRoom ? "Activate Flat" : "Deactivate Flat";
    const isLoading = isActivateRoom ? activateFlatLoading : deactivateFlatLoading;
    const loadingText = isActivateRoom ? "Activating..." : "Deactivating...";
    return (
        <Model
            width={"w-full max-w-md"}
            setOpenModel={setFlatModel}
            title="Edit Flat"
        >
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleEditSubmit}
            >
                {() => (
                    <Form>
                        <InputGroup>
                            <Label>Flat No.</Label>
                            <Field
                                type="text"
                                name="roomNumber"
                                className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                placeholder="Enter Room No."
                            />
                            <ErrorMessage
                                name="roomNumber"
                                component="div"
                                className="text-red-500 text-sm mt-1"
                            />
                        </InputGroup>

                        <div className="w-full flex justify-between space-x-6 my-4">
                            <SideCancelBtn onClick={() => setFlatModel(false)}>
                                Cancel
                            </SideCancelBtn>
                            <SubmitBtn type="submit" disabled={editFlatNumberLoading} className="border border-primary-color bg-white text-primary-color hover:bg-primary-color hover:text-white">
                                {" "}
                                {editFlatNumberLoading ? "Editing..." : "Edit"}
                            </SubmitBtn>
                        </div>

                        <DeactivateRoomBtn
                            type="button"
                            onClick={handleRoomStatus}
                            disabled={selectedData.status !== Config.ROOM_STATUS.VACANT && selectedData.status !== Config.ROOM_STATUS.INACTIVE}
                            className={`w-full border items-center mb-2 h-12 rounded-lg 
                                ${isActivateRoom ? "border-green-500 text-green-500" : "border-red-500 text-red-500"}
                                disabled:opacity-50 disabled:cursor-not-allowed
                            `}
                        >
                            {isLoading ? (
                                loadingText
                            ) : (
                                buttonText
                            )}
                        </DeactivateRoomBtn>
                        <span className="text-center items-center flex justify-center text-sm text-gray-400">A flat must be vacant in order to be deactivate.</span>
                    </Form>
                )}
            </Formik>
        </Model>
    );
};

const SubTitle = tw.p`text-sm md:text-base text-left mb-6 text-gray-700 text-pretty pt-2`;
const DeactivateRoomBtn = tw.button`w-full border border-red-500 items-center mb-2 text-red-500 h-12 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed`;

export default EditFlat;